import React from 'react';
import { programs } from '../../data/programs';
import { site, socials } from '../../data/site';
import { Container } from '../ui/Container';
import { SocialIcon } from '../ui/SocialIcon';
import { programPaths, schoolLinks } from '../../data/navigation';
const headingClass = 'text-sm font-semibold uppercase tracking-[0.12em] text-white/55';
const linkClass = 'inline-flex min-h-[40px] items-center text-[15px] text-white/80 transition-colors duration-150 hover:text-white';
const footerSchoolLinks = [{
  label: 'Class schedule',
  href: '/schedule'
}, {
  label: 'Our coaches',
  href: '/instructors'
}, ...schoolLinks.filter(link => link.href !== '/more' && link.href !== '/free-trial-class')];
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="on-dark bg-black text-white" data-id="element-375" data-mp="3e2me0bdbvmiw">
      <Container className="grid gap-10 py-16 sm:grid-cols-2 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)_minmax(0,1.3fr)_minmax(0,0.85fr)] lg:gap-8" data-id="element-376" data-mp="3e2ckidt2qx8g">
        <div className="min-w-0" data-id="element-377" data-mp="2kcl4nccg0rxr">
          <a href="/" className="inline-flex items-center gap-4" data-id="element-378" data-mp="2kcbenoreeks2">
            <img src={site.logo} alt="" className="h-24 w-auto" loading="lazy" data-id="element-379" data-mp="2p4cybvqwbds4" />
            <span className="font-display text-[1.75rem] font-bold uppercase leading-[0.95] tracking-wide" data-id="element-380" data-mp="2bcexe87c8o71">
              Bates
              <br data-id="element-381" data-mp="2gaq78ixmuyp9" />
              Taekwondo
            </span>
          </a>
          <address className="mt-5 not-italic text-[15px] leading-relaxed text-white/80" data-id="element-382" data-mp="341der33mzmba">
            {site.street}
            <br data-id="element-383" data-mp="382yzfamex4w1" />
            {site.cityLine}
          </address>
          <ul className="mt-2" data-id="element-384" data-mp="380crvaziupdt">
            <li data-id="element-385" data-mp="2u3pig8qdu6r0">
              <a href={site.directionsUrl} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-386" data-mp="2u24nwj42int5">
                Get directions<span className="sr-only" data-id="element-387" data-mp="2z067r69bir5o"> (opens in a new tab)</span>
              </a>
            </li>
            <li data-id="element-388" data-mp="1img3nzi782w1">
              <a href={site.phoneHref} className={linkClass} data-id="element-389" data-mp="1iq3ugqw9eb72">
                {site.phoneDisplay}
              </a>
            </li>
            <li data-id="element-390" data-mp="13kzfeoked6xy">
              <a href={site.emailHref} className={linkClass} data-id="element-391" data-mp="13joeqxm90fb2">
                {site.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="min-w-0" data-id="element-392" data-mp="usfpcci68aoq">
          <h2 className={headingClass} data-id="element-393" data-mp="urmht9be1h5j">Programs</h2>
          <ul className="mt-3" data-id="element-394" data-mp="uq2wh4avkfww">
            <li data-id="element-395" data-mp="ptuocav3hmz8"><a href="/programs" className={linkClass} data-id="element-396" data-mp="pu4f40nyry5z">All programs</a></li>
            {programs.map(p => <li key={p.id} data-id="element-397" data-mp="kvayw0halt24">
                <a href={programPaths[p.id]} className={linkClass} data-id="element-398" data-mp="kvjfo3gjdiil">
                  {p.name}
                </a>
              </li>)}
            <li data-id="element-399" data-mp="bt1p5ctum3ps">
              <a href="/free-trial-class" className={linkClass} data-id="element-400" data-mp="bul85b6w2sv9">
                Free trial class
              </a>
            </li>
          </ul>
        </div>

        <div className="min-w-0" data-id="element-401" data-mp="267ks1giay98c">
          <h2 className={headingClass} data-id="element-402" data-mp="267ui143ckge1">School information</h2>
          <ul className="mt-3" data-id="element-403" data-mp="218hyas7rvpfo">
            {footerSchoolLinks.map(link => <li key={link.href} data-id="element-404" data-mp="21915bdvvwtex"><a href={link.href} className={linkClass} data-id="element-405" data-mp="216ewzc1669vn">{link.label}</a></li>)}
          </ul>
        </div>

        <div className="min-w-0" data-id="element-406" data-mp="28q6cquq1y36c">
          <h2 className={headingClass} data-id="element-407" data-mp="2dqke5tx5eeve">Follow Bates</h2>
          <ul className="mt-3" data-id="element-408" data-mp="2dp0tlr4glhnt">
            {socials.map(s => <li key={s.name} data-id="element-409" data-mp="2ij51qdpgnvqh">
                <a href={s.href} target="_blank" rel="noopener noreferrer" className={`${linkClass} gap-3`} data-id="element-410" data-mp="2ik6ecmm4kqab">
                  <SocialIcon name={s.name} className="h-[18px] w-[18px]" data-id="element-411" data-mp="1pt4uw9beg8kz" />
                  {s.label}
                  <span className="sr-only" data-id="element-412" data-mp="1us83g3ql8wxp"> (opens in a new tab)</span>
                </a>
              </li>)}
          </ul>
        </div>
      </Container>
      <div className="border-t border-white/10" data-id="element-413" data-mp="1zq17aq4f5eut">
        <Container className="flex flex-col gap-2 py-6 text-sm text-white/55 sm:flex-row sm:justify-between" data-id="element-414" data-mp="23tfnphw9rx8s">
          <p data-id="element-415" data-mp="3b798z3nokgva">© {year} Bates Taekwondo. All rights reserved.</p>
          <p data-id="element-416" data-mp="3f82xnz8y5zp8">
            {site.street}, {site.cityLine}
          </p>
        </Container>
      </div>
    </footer>;
}